import { useState } from 'react';
import type { FormEvent } from 'react';

import { editarNome } from '../api/participantes';
import type { Participante } from '../api/participantes';
import { formatarMatricula } from '../matricula';
import { JanelaModal } from './JanelaModal';

interface EdicaoDeDadosProps {
    participante: Participante;
    csrfToken: string;
    aoSalvar: () => void;
    aoFechar: () => void;
}

/**
 * Editar dados (`PT7`): só o nome muda (`DP-PT-010`, `RN-PT-041`). A matrícula aparece só para
 * leitura; Cancelar descarta, e uma falha deixa o formulário aberto com o que foi digitado.
 */
export function EdicaoDeDados({ participante, csrfToken, aoSalvar, aoFechar }: EdicaoDeDadosProps) {
    const [nome, setNome] = useState(participante.nome ?? '');
    const [erro, setErro] = useState<string | null>(null);
    const [processando, setProcessando] = useState(false);

    async function salvar(evento: FormEvent) {
        evento.preventDefault();
        if (processando) return;
        if (!nome.trim()) return setErro('Informe o nome.');
        setErro(null);
        setProcessando(true);
        try {
            await editarNome({ participante, nome: nome.trim(), csrfToken });
            aoSalvar();
        } catch {
            setErro('Não foi possível salvar os dados.');
        } finally {
            setProcessando(false);
        }
    }

    return (
        <JanelaModal titulo="Editar dados" aoFechar={aoFechar} bloqueada={processando}>
            <form className="formulario-participante" onSubmit={(evento) => void salvar(evento)} noValidate>
                <label>
                    Matrícula
                    <input type="text" value={formatarMatricula(participante.matricula)} readOnly />
                </label>
                <label>
                    Nome
                    <input type="text" maxLength={120} value={nome} onChange={(evento) => setNome(evento.target.value)} />
                </label>
                <p className="dados-fixos">
                    Turma {participante.turma_id} · {participante.grupo_id ? `Grupo ${participante.grupo_nome ?? participante.grupo_id}` : 'Sem grupo'}
                </p>
                {erro && <p className="erro-formulario" role="alert">{erro}</p>}
                <div className="botoes-confirmacao">
                    <button type="button" className="botao-secundario" onClick={aoFechar} disabled={processando}>Cancelar</button>
                    <button type="submit" className="botao-confirmar" disabled={processando}>
                        {processando ? 'Processando…' : 'Salvar'}
                    </button>
                </div>
            </form>
        </JanelaModal>
    );
}
